import{_ as e}from"./_rollupPluginBabelHelpers-fc5c8eb1.js";import*as r from"react";import{S as t}from"./styled-16d7458e.js";import"styled-components";import"./theme.js";var o=function(o){return r.createElement(t,e({},o,{role:"button"}))};export{o as Dot};
//# sourceMappingURL=Dot.js.map
